import SVGInjector from 'svg-injector';

const sectorButtonImgIcons = document.querySelectorAll('.deepsea-sector-button img');
Array.from(sectorButtonImgIcons).forEach((img) => {
  SVGInjector(img, { evalScripts: false });
});
